import {
    Component,
    ElementRef,
    HostListener,
    OnDestroy,
    OnInit,
    QueryList,
    ViewChild,
    ViewChildren,
} from '@angular/core';
import { UserAuthService } from '../../../services/user/user-auth.service';
import { TitleService } from '../../../services/title/title.service';
import { environment } from '../../../../environments/environment';
import { AlertService } from '../../../services/alert/alert.service';
import { MenuContextService } from '../../layout/services/menu-context.service';
import { GetFaceMapOutPut, ScreenLocationService } from '../../private-campaign/services/screenLocation.service';
import {
    FilteredFaceDetailsParams,
    FaceService,
} from '../../private-campaign/services/face.service';
import {
    CampaignService,

} from '../../private-campaign/services/campaign.service';
import {
    SignalrService,
    RefreshedDataAction,
    RefreshedDataPayload,
} from '../../../services/signalr/signalr.service';
import { Subscription, debounceTime, interval } from 'rxjs';
import { ShutterComponent } from '../../filter/shutter/shutter.component';
import {
    TagCategory,
    UserTagsService,
} from '../../../services/user/userTags.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import {
    WEATHER_PARAMS,
    WEATHER_PARAMS_ICONS,
} from '../../weather/weather.model';
import {
    GetFaceOutput,
    ClientFaces,
    ClientFaceDetail,
    ClientFaceDiffusion,
    DayOfWeekFlags,
    WancomFaces,
    DiffusionSpot,
    WancomCampaign,
    FaceDiffusion,
} from '../park.model';
import { WvSimpleSpotFile } from '../../spots/model/wFile';
import { DatePipe } from '@angular/common';
import {
    GetDeviceListPowerStatusResponse,
    RemoteTvCmdService,
} from '../../../services/remote-Tv-Cmd/remote-tv-cmd.service';
import { WvGuidedTourService } from '../../../services/guided-tour/guided-tour.service';
import { WaitingService } from '../../layout/waiting/waiting.service';
import { Crisp } from 'crisp-sdk-web';
import { MatAccordion } from '@angular/material/expansion';
import { FormControl } from '@angular/forms';
import { ShutterService } from '../../filter/shutter/services/shutter.service';
import { MatMenu } from '@angular/material/menu';
import { ScreenInfoComponent } from '../screen-info/screen-info.component';
import { HttpErrorResponse } from '@angular/common/http';
import { GoogleMap, MapMarker } from '@angular/google-maps';
import { trigger, state, style, transition, animate } from '@angular/animations';

const NB_ITEM_BY_PAGE = 20;

@Component({
    selector: 'wnvw-park',
    templateUrl: './park.component.html',
    styleUrls: ['./park.component.scss'],
    animations: [
        trigger('fadeInRight', [
            state('void', style({ opacity: 0, marginLeft: '-500px' })),
            state('*', style({ opacity: 1 })),
            transition('void => *', [animate('0.3s 0.2s ease-in')]),
            transition('* => void', [animate('0.2s ease-in')])
        ]),
        trigger('fadeInDown', [
            state('void', style({ opacity: 0, marginTop: '-500px' })),
            state('*', style({ opacity: 1 })),
            transition('void => *', [animate('0.3s 0.2s ease-in')]),
            transition('* => void', [animate('0.2s ease-in')])
        ])
    ],
})
export class ParkComponent implements OnInit, OnDestroy {

    //#region Variables

    @ViewChild('infiniteScrollParentElem')
    public infiniteScrollParentElem: ElementRef;
    @ViewChild('filterShutter') public filterShutter: ShutterComponent;
    private readonly baseUrl: string;
    public baseUrlPdf: string;
    public loaded: boolean = false;
    public organizationLocations: GetFaceOutput;
    public filterParams: FilteredFaceDetailsParams;
    private refreshedDataSubscription: Subscription;
    private spotsProgressionDataSubscription: Subscription;

    /**
     * Mode de vue de la page Park
     */
    public globalViewMode: ParkViewMode = ParkViewMode.ListView;
    /**
     * Options de la carte
     */
    public mapOptions: google.maps.MapOptions = {
        // center: { lat: 46.362301586334988, lng: 2.5612295000000813 }, //Center France by default
        disableDefaultUI: true,
        gestureHandling: 'greedy',
        zoom: 6,
        styles: [
            { elementType: 'geometry', stylers: [{ color: '#f5f5f5' }] },
            { elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
            {
                elementType: 'labels.text.fill',
                stylers: [{ color: '#616161' }],
            },
            {
                elementType: 'labels.text.stroke',
                stylers: [{ color: '#f5f5f5' }],
            },
            {
                featureType: 'administrative.land_parcel',
                elementType: 'labels.text.fill',
                stylers: [{ color: '#bdbdbd' }],
            },
            {
                featureType: 'poi',
                elementType: 'geometry',
                stylers: [{ color: '#eeeeee' }],
            },
            {
                featureType: 'poi',
                elementType: 'labels.text.fill',
                stylers: [{ color: '#757575' }],
            },
            {
                featureType: 'poi.park',
                elementType: 'geometry',
                stylers: [{ color: '#e5e5e5' }],
            },
            {
                featureType: 'poi.park',
                elementType: 'labels.text.fill',
                stylers: [{ color: '#9e9e9e' }],
            },
            {
                featureType: 'road',
                elementType: 'geometry',
                stylers: [{ color: '#ffffff' }],
            },
            {
                featureType: 'road.arterial',
                elementType: 'labels.text.fill',
                stylers: [{ color: '#757575' }],
            },
            {
                featureType: 'road.highway',
                elementType: 'geometry',
                stylers: [{ color: '#dadada' }],
            },
            {
                featureType: 'road.highway',
                elementType: 'labels.text.fill',
                stylers: [{ color: '#616161' }],
            },
            {
                featureType: 'road.local',
                elementType: 'labels.text.fill',
                stylers: [{ color: '#9e9e9e' }],
            },
            {
                featureType: 'transit.line',
                elementType: 'geometry',
                stylers: [{ color: '#e5e5e5' }],
            },
            {
                featureType: 'transit.station',
                elementType: 'geometry',
                stylers: [{ color: '#eeeeee' }],
            },
            {
                featureType: 'water',
                elementType: 'geometry',
                stylers: [{ color: '#c9c9c9' }],
            },
            {
                featureType: 'water',
                elementType: 'labels.text.fill',
                stylers: [{ color: '#9e9e9e' }],
            },
        ],
        clickableIcons: false,
    };

    @ViewChild(GoogleMap, { static: false }) map: google.maps.Map;

    /**
     * Liste des points sur la carte
     */
    public markers: ParkMapMarker[] = [];

    /**
     * Coordonnées du centre de la carte, par défaut la France
     */
    public center = { lat: 46.362301586334988, lng: 2.5612295000000813 };

    window: Window;
    public total$: any;

    filter: boolean;

    //Filtres
    haveMoreResult: boolean;
    selected: string;

    public parkScrollLoaded: boolean = false;

    public shutterName = 'Filtrer vos écrans';

    //Weather Params
    public weatherParams: string[];
    public weatherParamsIcons: string[];
    public dayOfWeekFlags: DayOfWeekFlags;

    private readonly maxDayToDisplay = 100;
    /**
     * Liste de FaceIds d'écrans MagicInfo allumés
     */
    public poweredFaceIds: GetDeviceListPowerStatusResponse[];

    /**
     * Temps en millisecondes du refresh automatique du status MagicInfo des écrans
     */
    private readonly refreshTimerMs = 900000; // 15min
    public autoRefreshSubscribe: Subscription = null;
    public isMobile: boolean = false;

    /**
     * @deprecated passe dans la liste des ScreenInfoComponent
     */
    @ViewChildren(MatAccordion) allExpanders: QueryList<MatAccordion>;

    /**
     * Elements 'ecran' dans la page
     */
    @ViewChildren(ScreenInfoComponent) screens: QueryList<ScreenInfoComponent>;

    public searchQuery: any;

    // containeur des catégorie et des tags dispo
    public categoriesAndTag: any;
    menuRefs = new Map<string, MatMenu>();
    @ViewChildren('menuRef') menuList!: QueryList<MatMenu>;
    public selection: Map<string, TagCategory>;

    // variable d'enregistrement des derniers filterParams passé
    public initialFilterParams: any = null;

    // Variable pour savoir si tout les expander sont clos ou non?
    public allExpandersClosed = false;

    // ordonner par
    public groupBy: FormControl;
    /**
     * Liste des face dans la map
     */
    public faceMaps: GetFaceMapOutPut[] = [];
    /**
     * Emplacement sélectionné dans la map
     */
    selectedMapScreens: GetFaceOutput = null;
    /**
     * Point sélectionné sur la map
     */
    selectedMarker: google.maps.Marker;
    /**
     * Loader du détail des écrans dans la map
     */
    isMapInfoLoading: boolean = false;
    //#endregion Variables

    // MARK: Constructor
    constructor(
        public faceService: FaceService,
        private readonly campaign$: CampaignService,
        private readonly userAuth$: UserAuthService,
        private readonly title: TitleService,
        private readonly signalr: SignalrService,
        public alert$: AlertService,
        public menuContext$: MenuContextService,
        private readonly router: Router,
        public screenLocations$: ScreenLocationService,
        public dialog: MatDialog,
        public datePipe: DatePipe,
        public remotTvCmd$: RemoteTvCmdService,
        private readonly wvGuidedTour$: WvGuidedTourService,
        public waiting$: WaitingService,
        private readonly shutter: ShutterService
    ) {
        this.baseUrl = environment.apiBaseUrl;
        this.baseUrlPdf = environment.apiBasePdf;
        setTimeout(() => {
            this.title.next('Parc');
        }, 0);
        this.window = <Window>window;

        this.filterParams = new FilteredFaceDetailsParams();
        this.organizationLocations = { clients: [], wancoms: [] };

        this.weatherParams = WEATHER_PARAMS;
        this.weatherParamsIcons = WEATHER_PARAMS_ICONS;
        this.haveMoreResult = true;

        this.selection = new Map<string, TagCategory>();


    }

    async ngOnInit(): Promise<void> {

        this.groupBy = new FormControl();
        this.searchQuery = new FormControl();

        this.menuContext$.next(true);
        await this.userAuth$.refreshUserInfos();
        this.filterParams.page = 0;
        this.filterParams.pageSize = NB_ITEM_BY_PAGE;
        this.selection = UserTagsService.getTagsSelection(this.shutterName);
        this.filterParams.tags = UserTagsService.getSelectedTags(this.selection);
        this.filterParams.faceIds = UserTagsService.getSelectedTags(this.selection, 1);

        //SIGNALR HANDLER
        this.initSignalRHandle();

        this.onResize(null);


        this.globalViewMode = !isNaN(parseInt(localStorage.getItem('parkViewMode'))) ? parseInt(localStorage.getItem('parkViewMode')) : ParkViewMode.ListView;

        this.loadScreenData();
        this.callbackUntilScrollable();
        // this.initMapDrag();

        if (!Crisp.isCrispInjected()) {
            Crisp.configure('7d4a0471-984f-4f44-a5cd-e0ef1ef779b4');
        } else {
            Crisp.chat.show();
        }


        // Gestion du l'ordonnancement par tag
        this.groupBy.valueChanges.pipe(debounceTime(700)).subscribe((query) => {
            if (query) {
                this.filterParams.groupBy = 1;
                this.filterParams.groupById = query;
                this.filterParams.page = 0;
                this.organizationLocations = { clients: [], wancoms: [] };
                this.loadScreenData();
                this.callbackUntilScrollable();
            }
            else {
                this.filterParams.groupBy = 0;
                this.filterParams.page = 0;

                this.filterParams.groupById = null;
                this.organizationLocations = { clients: [], wancoms: [] };
                this.loadScreenData();
                this.callbackUntilScrollable();
            }

        })
    }

    private initSignalRHandle() {
        this.refreshedDataSubscription = this.signalr.RefreshedData.subscribe(
            (data: RefreshedDataPayload) => {
                switch (data.action) {
                    case RefreshedDataAction.DeleteCampaign:
                        /* Unused */
                        break;
                    case RefreshedDataAction.SetPlaylistOrder:
                        this.alert$.show({
                            message: 'Nouvel ordre de playlist enregistré !',
                            duration: 1000,
                        });
                        break;
                    case RefreshedDataAction.UpdateSpot: {
                        //format : {spotId}:{generationStatus}:{storageId}:{thumbnailId}
                        console.log('SignalR - Update Spot', data);

                        const splittedData: string[] = data.data.split(':');
                        const spotId: number = parseInt(splittedData[0]);
                        const updatedFile: WvSimpleSpotFile = {
                            storageId: splittedData[2] ?? null,
                            thumbnailStorageId: splittedData[3] ?? null,
                            generationStatus: parseInt(splittedData[1]) ?? null,
                        };

                        const diffList: FaceDiffusion[] = this.getDiffsBySpot(spotId);
                        diffList.forEach((diffusion: FaceDiffusion) => {
                            this.updateDiffusion(
                                diffusion,
                                spotId,
                                updatedFile
                            );
                        });

                        break;
                    }
                    case RefreshedDataAction.UpdateCampaign:
                        console.log('SignalR - Update Campaign', data);

                        this.refreshAllPark();
                        break;

                    case RefreshedDataAction.CreateCampaign:
                        console.log('SignalR - Create Campaign', data);
                        this.refreshAllPark();
                        break;
                    default:
                        console.log('SignalR - unknown', data);

                        break;
                }
            }
        );
        //Spot Loading handler
        this.spotsProgressionDataSubscription =
            this.signalr.SpotsProgressionData.subscribe((data: string) => {
                console.log('SpotsProgression : ' + data);
                //format {SpotId}:{FormatTypeId}:{Progression}:{storageId}:{thumbnailStorageId}
                const info: string[] = data.split(':');
                const spotId: number = parseInt(info[0]);
                const formatTypeId: number = parseInt(info[1]);
                const progression: number = parseInt(info[2]);

                const finished: boolean = progression === 100;
                let storageId: string = '';
                let thumbnailStorageId: string = '';
                if (finished) {
                    // Lorsque la conversion est terminée, on a les infos de fichier
                    storageId = info[3];
                    thumbnailStorageId = info[4];
                }

                //Récupère toutes les diffs avec le spotId et le spotFormatId
                const diffs: FaceDiffusion[] = this.getDiffsBySpot(
                    spotId,
                    formatTypeId
                );

                diffs.forEach((diffusion: FaceDiffusion) => {
                    diffusion.spots.forEach((spot: DiffusionSpot) => {
                        if (finished) {
                            this.updateSpotCompleted(
                                spot,
                                spotId,
                                storageId,
                                thumbnailStorageId
                            );
                        } else {
                            this.updateSpotProgress(spot, spotId, progression);
                        }
                    });
                });
            });
    }

    /**
     *
     * @param spot
     * @param spotId
     * @param progression
     */
    private updateSpotProgress(
        spot: DiffusionSpot,
        spotId: number,
        progression: number
    ) {
        if (spot.spotId === spotId) {
            spot.file = spot.file ?? {
                storageId: null,
                thumbnailStorageId: null,
            };

            spot.file.generationStatus = 20;
            spot.file.generationProgress = progression;
        }
    }

    private updateSpotCompleted(
        spot: DiffusionSpot,
        spotId: number,
        storageId,
        thumbnailStorageId
    ) {
        if (spot.spotId === spotId) {
            spot.file = spot.file ?? {
                storageId: null,
                thumbnailStorageId: null,
            };

            spot.file.storageId = storageId;
            spot.file.thumbnailStorageId = thumbnailStorageId;
            spot.file.generationStatus = 30;
            spot.file.generationProgress = 100;
        }
    }

    ngOnDestroy(): void {
        if (this.refreshedDataSubscription) {
            this.refreshedDataSubscription.unsubscribe();
        }
        if (this.spotsProgressionDataSubscription) {
            this.spotsProgressionDataSubscription.unsubscribe();
        }
        if (this.autoRefreshSubscribe) {
            this.autoRefreshSubscribe.unsubscribe();
        }
    }

    /**
     * Get diffusions which contains the spot with the id given
     *
     * @param selectedSpotId SpotId which filter the diffusions
     * @param formatTypeId an optional format Id
     * @returns A list of Diffusions `FaceDiffusion[]` which contains the selected spot
     */
    private getDiffsBySpot(
        selectedSpotId: number,
        formatTypeId?: number
    ): FaceDiffusion[] {
        let matchingDiffs: FaceDiffusion[] = [];

        if (this.organizationLocations?.clients) {
            this.organizationLocations.clients.forEach(
                (orgLocClient: ClientFaces) => {
                    orgLocClient.faces.forEach((face: ClientFaceDetail) => {
                        if (
                            !formatTypeId ||
                            formatTypeId === face.formatTypeId
                        ) {
                            face.diffusions.forEach(
                                (diff: ClientFaceDiffusion) => {
                                    diff.spots.forEach(
                                        (spot: DiffusionSpot) => {
                                            if (spot.spotId === selectedSpotId)
                                                matchingDiffs.push(diff);
                                        }
                                    );
                                }
                            );
                        }
                    });
                }
            );
        }

        if (this.organizationLocations?.wancoms) {
            this.organizationLocations.wancoms.forEach(
                (orgLocWncm: WancomFaces) => {
                    orgLocWncm.campaigns.forEach((campaign: WancomCampaign) => {
                        campaign.diffusions.forEach((diff: FaceDiffusion) => {
                            diff.spots.forEach((spot: DiffusionSpot) => {
                                if (spot.spotId === selectedSpotId)
                                    matchingDiffs.push(diff);
                            });
                        });
                    });
                }
            );
        }

        return matchingDiffs;
    }

    /**
     * Charge les données des écrans
     */
    private loadScreenData() {
        if (this.globalViewMode === ParkViewMode.ListView) {


            const waitingId: string = this.waiting$.start();
            this.parkScrollLoaded = false;

            this.initialFilterParams = { ...this.filterParams };
            this.screenLocations$.getFace(this.filterParams).subscribe({
                next: (item: GetFaceOutput) => {
                    this.waiting$.end(waitingId);
                    this.haveMoreResult =
                        item.clients?.length > 0 || item.wancoms?.length > 0;

                    if (
                        this.organizationLocations.clients?.length === 0 &&
                        this.organizationLocations.wancoms?.length === 0
                    ) {
                        this.organizationLocations = item;
                    } else {
                        this.GetClientsScreens(item);

                        this.GetWancomsScreens(item);
                    }

                    if (this.userAuth$.hasRight('CanSeeMonitoring')) {
                        this.getDevicesPowerStatus();

                        if (this.autoRefreshSubscribe == null) {
                            this.refreshPowerStatus(this.refreshTimerMs);
                        }
                    } else {
                        this.poweredFaceIds = null;
                    }

                    this.loaded = true;
                    this.parkScrollLoaded = true;

                    if (item.wancoms != null && this.filterParams.page === 0) {
                        setTimeout(() => {
                            this.wvGuidedTour$.launchParkTour();
                        }, 0);
                    }

                    if (this.allExpandersClosed) {
                        setTimeout(() => {
                            this.closeAllExpanders();
                        }, 100)
                    }

                    setTimeout(() => {
                        const scrollContainer = document.getElementsByClassName('tagList');
                        Array.from(scrollContainer).forEach(element => {
                            element.addEventListener('wheel', (evt: WheelEvent) => {
                                evt.preventDefault();
                                element.scrollLeft += evt.deltaY;
                            });
                        });
                    }, 1000);
                },
                error: (err) => {
                    this.waiting$.end(waitingId);
                    console.error(err);

                    this.alert$.show({
                        message:
                            'Erreur lors du chargement des écrans, veuillez réessayer plus tard',
                        duration: 1700,
                    });

                    this.loaded = true;
                    this.parkScrollLoaded = true;
                },
            });
        } else {
            this.loadMap();
        }

        this.initialFilterParams = { ...this.filterParams };
    }

    /**
     * Rafraichit le statut des écrans sur MagicInfo
     * @param timerMs 
     */
    private refreshPowerStatus(timerMs: number) {
        this.autoRefreshSubscribe = interval(timerMs).subscribe(() => {
            if (this.userAuth$.hasRight('CanSeeMonitoring')) {
                this.poweredFaceIds = null;
                this.getDevicesPowerStatus();
            }
        });
    }

    private getDevicesPowerStatus() {
        let faceIds: number[] = [];
        if (this.organizationLocations.clients) {
            this.organizationLocations.clients.forEach(
                (clientFace: ClientFaces) => {
                    clientFace.faces.forEach((face: ClientFaceDetail) => {
                        if (face.isMagicInfo) {
                            faceIds.push(face.faceId);
                        }
                    });
                }
            );
        }

        this.remotTvCmd$.getDeviceListPowerStatus(faceIds).subscribe({
            next: (poweredFaceIds?: GetDeviceListPowerStatusResponse[]) => {
                if (poweredFaceIds) {
                    this.poweredFaceIds = poweredFaceIds;

                    this.organizationLocations.clients.forEach(
                        (clientFace: ClientFaces) => {
                            clientFace.faces.forEach(
                                (face: ClientFaceDetail) => {
                                    face.powerStatus_MagicInfo =
                                        this.isFacePowered(face.faceId);
                                }
                            );
                        }
                    );
                }
            },
            error: (err) => {
                console.error("ParkComponent - getDevicePowerStatus() : ", err);

                this.poweredFaceIds = null;
                //On arrête d'appeler en boucle
                this.autoRefreshSubscribe.unsubscribe();
            },
        });
    }

    isFacePowered(faceId: number): MagicInfoPowerStatus {
        const faceStatus: GetDeviceListPowerStatusResponse[] =
            this.poweredFaceIds.filter(
                (currentFace: GetDeviceListPowerStatusResponse) => {
                    return currentFace.faceId === faceId;
                }
            );




        const isPowerOn = (currentDevice: GetDeviceListPowerStatusResponse) =>
            currentDevice.power === true;

        const isPowerOff = (currentDevice: GetDeviceListPowerStatusResponse) =>
            currentDevice.power === false;

        if (faceStatus?.length > 0) {
            if (faceStatus.every(isPowerOn)) {
                return MagicInfoPowerStatus.On;
            } else if (faceStatus.every(isPowerOff)) {
                return MagicInfoPowerStatus.Off;
            } else {
                return faceStatus != null
                    ? MagicInfoPowerStatus.HalfOn
                    : MagicInfoPowerStatus.Unknown;
            }
        } else {
            //Le face Id n'existe pas dans la liste retournée par MagicInfo
            return MagicInfoPowerStatus.Unknown;
        }
    }

    /**
     * Get all Wancom screens from screenLocation/GetFace
     * @param item `GetFaceOutput` item returned from screenLocation/getFace
     */
    private GetWancomsScreens(item: GetFaceOutput): void {
        if (item?.wancoms != null) {
            this.organizationLocations.wancoms = [];
            item.wancoms.forEach((wancom: WancomFaces) => {
                if (!this.organizationLocations.wancoms) {
                    this.organizationLocations.wancoms = [];
                }
                this.organizationLocations.wancoms.push(wancom);
            });
        }
    }

    /**
     *	Get all Clients screens from screenLocation/getFace
     *
     * @param item `GetFaceOutput` item returned from screenLocation/getFace
     */
    private GetClientsScreens(item: GetFaceOutput): void {
        if (item?.clients != null) {
            this.organizationLocations.clients = [];
            item.clients.forEach((client: ClientFaces) => {
                //must ckeck if client.organization already exist
                let currentClientName: string = client.organizationName;
                if (this.organizationLocations.clients == null) {
                    this.organizationLocations.clients = [];
                }
                let existingclientIndex: number =
                    this.organizationLocations.clients.findIndex(
                        (currentClientFace: ClientFaces) =>
                            currentClientFace.organizationName ===
                            currentClientName
                    );
                if (existingclientIndex !== -1) {
                    client.faces.forEach((face: any) => {
                        this.organizationLocations.clients[existingclientIndex].faces.push(face);
                    });
                } else {
                    this.organizationLocations.clients.push(client);
                }
            });
        }
    }

    /**
     * Mets à jour l'ordre dans la playlist
     * @param faceId Id de la face
     */
    public updatePlaylistOrder(faceId: number) {
        let newDiffusionList: ClientFaceDiffusion[] = [];

        //Récupère la playlist front
        this.organizationLocations.clients.forEach(
            (clientFace: ClientFaces) => {
                const faces: ClientFaceDetail = clientFace.faces?.find(
                    (faceDetail: ClientFaceDetail) => {
                        return faceDetail.faceId === faceId;
                    }
                );

                if (faces !== undefined) newDiffusionList = faces.diffusions;
            }
        );

        let diffusionIdList: number[] = [];

        newDiffusionList.forEach((diff: ClientFaceDiffusion) => {
            diffusionIdList.push(diff.diffusionId);
        });

        this.screenLocations$.setPlaylistOrder(faceId, diffusionIdList);
    }

    /**
     * Retrieve the Campaign data from BackEnd
     *
     * @param selectedDiff diffusion to update
     */
    private updateDiffusion(
        selectedDiff: FaceDiffusion,
        spotId: number,
        updatedFile: WvSimpleSpotFile
    ) {
        selectedDiff.spots.forEach((spot: DiffusionSpot) => {
            if (spot.spotId === spotId) {
                spot.file = spot.file ?? {
                    storageId: null,
                    thumbnailStorageId: null,
                };

                spot.file.storageId = updatedFile.storageId;
                spot.file.thumbnailStorageId = updatedFile.thumbnailStorageId;
                spot.file.generationStatus = updatedFile.generationStatus;
            }
        });
    }

    @HostListener('window:resize', ['$event'])
    onResize(event?) {
        event?.preventDefault();
        this.isMobile = this.window.innerWidth <= 900;
    }

    scroll(el: HTMLElement, operator: string) {
        if (operator === '+') {
            el.scrollLeft += 100;
        }
        if (operator === '-') {
            el.scrollLeft -= 100;
        }
        setTimeout(() => {
            if (el.scrollLeft > 0) {
                const parent = el.parentElement;
                const left = parent.querySelector('.left-btn');
                left.classList.remove('hide');
            } else {
                const parent = el.parentElement;
                const left = parent.querySelector('.left-btn');
                left.classList.add('hide');
            }
            if (el.scrollLeft + el.clientWidth === el.scrollWidth) {
                const parent = el.parentElement;
                const right = parent.querySelector('.right-btn');
                right.classList.add('hide');
            } else {
                const parent = el.parentElement;
                const right = parent.querySelector('.right-btn');
                right.classList.remove('hide');
            }
        }, 200);
    }

    /**
     * Triggered by scrolling park list
     *
     *
     * Reload data
     */
    onScroll() {
        if (!this.haveMoreResult || !this.parkScrollLoaded) return;

        this.filterParams.page = this.filterParams.page + 1;
        this.loadScreenData();
        this.callbackUntilScrollable();
    }

    private callbackUntilScrollable() {
        window.setTimeout(() => {
            if (this.infiniteScrollParentElem) {
                if (
                    this.infiniteScrollParentElem.nativeElement.clientHeight >
                    this.infiniteScrollParentElem.nativeElement.scrollHeight -
                    30
                ) {
                    // this.onScroll();
                }
            } else {
                this.callbackUntilScrollable();
            }
        }, 500);
    }

    deleteWancomDiffusion(diffusion: FaceDiffusion) {
        if (!diffusion.isDefault) {
            this.campaign$
                .deleteDiffusion(diffusion.diffusionId)
                .subscribe(() => {
                    this.alert$.show({
                        message: 'Diffusion supprimée !',
                        duration: 500,
                    });
                    this.refreshAllPark();
                });
        } else {
            this.alert$.show({
                message:
                    'Erreur : la diffusion à supprimer est la diffusion par défaut',
                duration: 3000,
            });
        }
    }

    private refreshAllPark() {
        if (this.globalViewMode === ParkViewMode.ListView) {
            this.loaded = false;
            this.organizationLocations = { clients: [], wancoms: [] };
            this.filterParams.page = 0;
            this.loadScreenData();
        } else {
            this.loadMap();
        }
    }

    /**
     * Delete the entire diffusion
     *
     * @param diffusion diffusion to delete
     */
    deleteDiffusion(diffusion: any) {
        //Call back to delete
        this.campaign$.delete(diffusion.diffusionId).subscribe(() => {
            this.alert$.show({
                message: 'Diffusion supprimée !',
                duration: 500,
            });
            this.refreshAllPark();
        });
    }

    /**
     *
     * @param diffusion diffusion to remove from screen
     * @param faceId screen where the diffusion will be removed
     */
    deleteDiffForScreen(diffusion: FaceDiffusion, faceId: number) {
        //Call back to remove diffusion from screen

        this.screenLocations$
            .removeFaceFromCampaign(diffusion.diffusionId, faceId)
            .subscribe(() => {
                this.alert$.show({
                    message: 'Diffusion supprimée pour cet écran !',
                    duration: 500,
                });
                this.refreshAllPark();
            });
    }

    deleteWncmDiffFormScreen(diffusion: FaceDiffusion, faceId: number) {
        this.screenLocations$
            .removeWancomDiffFromFace(diffusion.diffusionId, faceId)
            .subscribe(() => {
                this.alert$.show({
                    message: 'Diffusion supprimée pour cet écran !',
                    duration: 500,
                });
                this.refreshAllPark();
            });
    }

    clearAllFilter() {
        UserTagsService.setTagsSelection(this.shutterName, []);
        this.filterParams.tags = [];
        this.filterParams.faceIds = [];
        this.searchQuery.setValue(null);
        this.loaded = false;
        this.loadScreenData();
    }

    ngAfterViewInit() {
        // Récupération de tous les tags dispos
        this.shutter.getAllTags().subscribe((val) => {
            this.categoriesAndTag = val;

        });
        setTimeout(() => {
            this.menuList.forEach((menu, index) => {
                const catName = this.categoriesAndTag[index].n;
                this.menuRefs.set(catName, menu);
            });
        }, 1000);
    }

    public launchGuidedTour() {
        setTimeout(() => {
            this.wvGuidedTour$.launchParkTour(true);
        }, 0);
    }

    public canShowGuidedTour(): boolean {
        return this.organizationLocations.wancoms != null && this.organizationLocations.wancoms?.length >= 0;
    }

    closeAllExpanders() {
        this.screens.forEach(screen => {

            screen.diffList.forEach(diffusion => {
                diffusion.allExpanders.forEach(element => {
                    element.closeAll();
                });
            })
        });
        this.allExpandersClosed = true;
    }

    openAllExpanders() {
        this.screens.forEach(screen => {
            screen.diffList.forEach(diffusion => {
                diffusion.allExpanders.forEach(element => {
                    element.openAll();
                });
            })
        });
        this.allExpandersClosed = false;
    }

    selectSubMenu(tag, cat) {
        if (this.selection.has(cat.n)) {
            const listTag = this.selection.get(cat.n);
            const index = listTag.t.findIndex(t => t.n === tag.n);
            if (index === -1) {
                listTag.t.push(tag)
            }
            else {
                listTag.t.splice(index, 1);
                if (listTag.t.length === 0)
                    this.selection.delete(cat.n);
            }
        }
        else {
            this.selection.set(cat.n, { i: tag.i, c: null, n: tag.n, t: [tag] });
        }
        UserTagsService.setTagsSelection("Filtrer vos écrans", this.selection);
        this.filterParams.page = 0;
        this.filterParams.pageSize = NB_ITEM_BY_PAGE;
        const selection = UserTagsService.getTagsSelection(this.shutterName);
        this.filterParams.tags = UserTagsService.getSelectedTags(selection);
        this.filterParams.faceIds = UserTagsService.getSelectedTags(selection, 1);
    }

    reloadPark(newFilterParams: FilteredFaceDetailsParams) {
        this.filterParams = newFilterParams;
        this.organizationLocations.clients = null;
        this.organizationLocations.wancoms = null;
        this.filterParams.page = 0;
        this.loadScreenData();
        this.callbackUntilScrollable();
    }

    initViewMap() {
        this.globalViewMode = ParkViewMode.MapView;
        localStorage.setItem('parkViewMode', this.globalViewMode.toString());

        // Charge les données de la map
        this.loadMap();
    }

    initViewList() {
        this.globalViewMode = ParkViewMode.ListView;
        localStorage.setItem('parkViewMode', this.globalViewMode.toString());

        this.loadScreenData();
    }

    private resetMapData() {
        this.selectedMapScreens = null;
        this.faceMaps = [];
        this.markers = [];
    }

    private loadMap() {
        const oldSelectedLocation = this.selectedMapScreens;
        this.resetMapData();


        this.loaded = false;

        const waitingId: string = this.waiting$.start();
        this.screenLocations$.getFaceMap(this.filterParams).subscribe({
            next: (result: GetFaceMapOutPut[]) => {
                this.waiting$.end(waitingId);

                this.faceMaps = result;

                if (oldSelectedLocation != null && result != null) {
                    this.isExistingSelection(oldSelectedLocation);
                }

                result.forEach((element: GetFaceMapOutPut, index: number) => {
                    this.markers.push({
                        index: index,
                        option: {
                            zIndex: 1,
                            icon: this.getMapIcon(element.screenParkId)
                        },
                        position: {
                            lat: element.gpsLatitude,
                            lng: element.gpsLongitude,
                        },
                    });
                });

                this.loaded = true;
            },
            error: (err: HttpErrorResponse) => {
                this.waiting$.end(waitingId);

                console.error("ParkComponent - loadMap() : ", err);

                this.alert$.show({
                    message: "Erreur lors du chargement de la carte"
                });

                this.loaded = true;
            }
        });
    }

    private isExistingSelection(oldSelectedLocation: GetFaceOutput): number {
        let allResultFaceId = [];

        let findFaceId = [];

        this.faceMaps.forEach((element) => {
            element.faces.forEach(face => {
                allResultFaceId.push(face.faceId);
            });
        });

        oldSelectedLocation?.clients?.find((element) => {
            let test = element.faces.find(f => {
                findFaceId.push(f.faceId)
                return allResultFaceId.includes(f.faceId);
            });
            return test != null;
        });

        if (findFaceId.length <= 0) {
            return;
        }

        let index = this.faceMaps.findIndex(fm => fm.faces.find(f => findFaceId.includes(f.faceId)));

        const filterParamsCopy: FilteredFaceDetailsParams = JSON.parse(JSON.stringify(this.filterParams));
        filterParamsCopy.page = null;
        filterParamsCopy.pageSize = null;
        filterParamsCopy.faceIds = findFaceId;

        this.loadMapInfoWindow(filterParamsCopy);

        return index;
    }

    private getMapIcon(screenParkId: number): string | google.maps.Icon | google.maps.Symbol {

        switch (screenParkId) {
            case 0:
                return 'https://wancomresource.s3.eu-west-3.amazonaws.com/LocalMain.svg';
            case 2:
                return 'https://wancomresource.s3.eu-west-3.amazonaws.com/weStoreSmallIcon.svg';

            case 1:
            default:
                return 'https://wancomresource.s3.eu-west-3.amazonaws.com/eg_outdoor.png';
        }
    }

    public clickMapMarker(clickedMapMarker: MapMarker, index?: number) {
        // Animate pin
        if (this.selectedMarker !== clickedMapMarker.marker) {
            this.selectedMarker?.setAnimation(null);
            this.selectedMarker = clickedMapMarker.marker;
            this.selectedMarker.setAnimation(
                google.maps.Animation.BOUNCE
            );

            let faceIDs = [];
            this.faceMaps[index].faces.forEach(f => {
                faceIDs.push(f.faceId);
            });

            const filterParamsCopy: FilteredFaceDetailsParams = JSON.parse(JSON.stringify(this.filterParams));
            filterParamsCopy.page = null;
            filterParamsCopy.pageSize = null;
            filterParamsCopy.faceIds = faceIDs;


            this.loadMapInfoWindow(filterParamsCopy);
        } else {
            //Already loaded location
        }

    }

    private loadMapInfoWindow(filterParamsCopy: FilteredFaceDetailsParams) {
        this.isMapInfoLoading = true;
        const waitingId: string = this.waiting$.start();
        this.screenLocations$.getFace(filterParamsCopy).subscribe({
            next: (res) => {
                this.waiting$.end(waitingId);
                this.selectedMapScreens = res;

                this.isMapInfoLoading = false;

                // allExpandersClosed ? openAllExpanders() : closeAllExpanders()
                setTimeout(() => {
                    this.allExpandersClosed ? this.closeAllExpanders() : this.openAllExpanders();
                }, 0)

            },
            error: (err: HttpErrorResponse) => {
                this.waiting$.end(waitingId);

                console.error("ParkComponent - getFaceMap()", err);
                this.selectedMarker.setAnimation(null);
                this.selectedMarker = null;
                this.isMapInfoLoading = false;
            }
        });
    }

    public closeInfoWindow() {
        this.selectedMapScreens = null;
        this.selectedMarker.setAnimation(null);

        this.selectedMarker = null;
    }

    public onMapDragEnd() {
        const mapCenter = this.map?.getCenter();
        this.center = { lat: mapCenter.lat(), lng: mapCenter.lng() };
    }

    public onMapZoomChanged() {
        this.mapOptions.zoom = this.map.getZoom();
        this.onMapDragEnd();
    }

    /**
     * getNbScreens
     */
    public getNbScreens(): number {
        if (this.selectedMapScreens != null) {
            return this.selectedMapScreens?.clients?.reduce(
                (sum, current) => sum + current?.faces?.length, 0) ?? 0 + this.selectedMapScreens?.wancoms?.length;
        } else {
            return null;
        }
    }

}

export enum MagicInfoPowerStatus {
    Unknown = 0,
    On = 1,
    Off = 2,
    HalfOn = 3,
    Loading = 4,
}

export enum ParkViewMode {
    ListView = 0,
    MapView = 1
}

export interface ParkMapMarker {
    index: number;
    /**
     * Positions GPS
     */
    position?: {
        /**
         * Latitude
         */
        lat: any;
        /**
         * Longitude
         */
        lng: any;
    };
    option?: google.maps.MarkerOptions;
}
